import { QuoteRequirementSection } from '~/lib/types/basket-types';
import { RequirementFieldProps } from './form-field-with-requirement';
import RequirementsField from './form-field-with-named-requirement';
import { useEffect, useState } from 'react';

export type RequirementsFieldProps = {
  name: string;
  requirements: QuoteRequirementSection;
} & RequirementFieldProps;

// This allows the ui to maintain its typed value, and defer any value update from state until the user has stopped typing.
// This allows the app to work as it did before, but allows the user to take longer to type values which cause issues, in this case 10.01 etc.
function RequirementsFieldDebounced(props: RequirementsFieldProps) {
  const [val, setVal] = useState(props.data);

  useEffect(() => {
    const t = setTimeout(() => setVal(props.data), 2500);
    return () => clearTimeout(t);
  }, [props.data]);

  return (
    <RequirementsField
      {...props}
      data={val}
      update={(v) => {
        setVal(v);
        props.update?.(v);
      }}
    />
  );
}
export default RequirementsFieldDebounced;
